"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.omitValues = exports.getDefaultLogMeta = exports.shouldLog = exports.currentConsolaLevel = exports.getLogLevel = exports.getColor = exports.getConsolaLevel = void 0;

var _consola = require("consola");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var COLORS = {
  fatal: '#c0392b',
  // red
  error: '#c0392b',
  // red
  warn: '#f39c12',
  // yellow
  success: '#2ecc71',
  // green
  info: '#00bcd4' // cyan

};
var DEFAULT_COLOR = '#7f8c8d'; // grey

/**
 * Get the consola level for a type.
 */

var getConsolaLevel = function getConsolaLevel(type) {
  var _consolaTypes$type;

  return (_consolaTypes$type = _consola._types[type]) === null || _consolaTypes$type === void 0 ? void 0 : _consolaTypes$type.level;
};
/**
 * Get the color for a type.
 */


exports.getConsolaLevel = getConsolaLevel;

var getColor = function getColor(type) {
  return COLORS[type] || DEFAULT_COLOR;
};
/**
 * Get the current log level.
 */


exports.getColor = getColor;

var getLogLevel = function getLogLevel() {
  return typeof window !== 'undefined' ? localStorage.logLevel : process.env.LOG_LEVEL;
};
/**
 * Get the current global type as a consola level.
 */


exports.getLogLevel = getLogLevel;

var currentConsolaLevel = function currentConsolaLevel() {
  var currentLevel = getLogLevel();
  var defaultLevel = 'info';
  return getConsolaLevel(currentLevel) || getConsolaLevel(defaultLevel);
};
/**
 * Return true if the given level should be logged, false otherwise.
 */


exports.currentConsolaLevel = currentConsolaLevel;

var shouldLog = function shouldLog(type) {
  return currentConsolaLevel() >= getConsolaLevel(type);
};
/**
 * Get the metadata to attach to all logs for certain reporters.
 */


exports.shouldLog = shouldLog;

var getDefaultLogMeta = function getDefaultLogMeta() {
  var meta = typeof window !== 'undefined' ? {} : process.env.LOG_META;

  try {
    return JSON.parse(meta);
  } catch (err) {
    return {};
  }
};
/**
 * Omit keys and their values from an obj
 * @param {object} omitObj '['cookie',authorization]'
 * @param {object} originalObj 'headers: { cookie: 'test', authorization: 'test2'... }
 * @returns a new object with the omitted keys and their values from the source object
 */


exports.getDefaultLogMeta = getDefaultLogMeta;

var omitValues = function omitValues(omitObj, originalObj) {
  return omitObj && originalObj ? Object.fromEntries(Object.entries(originalObj).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        k = _ref2[0];

    return !omitObj.includes(k);
  })) : originalObj;
};

exports.omitValues = omitValues;